<template>

    <header class="c-d_heading">
        <div class="c-d_heading__left">
            <slot></slot>
        </div>
        <div v-if="backHref" class="c-d_heading__right">
            <v-btn
                :to="backHref"
                type="back"
                class="c-d_heading__back">
                Wróć
            </v-btn>
        </div>
    </header>

</template>


<script>

import VBtn from 'Components/VBtn'

export default {

    props: {
        backHref: [Object, String]
    },

    name: 'TheDashboardHeading',

    components: {
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-d_heading {
    width: 100%;
    margin-bottom: 1.6rem;
    display: flex;
    flex-grow: 0;
    justify-content: space-between;
    align-items: flex-start;

    @include bp($screen-md) {
        padding: 0 20px;
        margin-bottom: 5px;
    }
    &__left {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        overflow: hidden;

        h2 {
            display: flex;
            max-width: 100%;
            flex-wrap: wrap;
            padding-right: 1.4rem;
            padding-bottom: 1rem;
            line-height: 2.4rem;

            a,
            span {
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding-right: .7rem;
            }
            a {
                color: inherit;
            }
            span {
                color: $c-sixth;
            }
            a:before,
            span:before {
                padding-right: .7rem;
                content: '>';
            }
            a:first-child:before {
                display: none;
            }
        }
    }
    &__right {
        padding-left: .5rem;
    }
    .c-btn {
        margin-bottom: 1rem;
    }
}

</style>
